import React from 'react'

const AppContext = React.createContext({} as AppContextData)
AppContext.displayName = 'AppContext'

export default AppContext
